var _path, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 42.1667C31 34.5 38.6667 27.6351 38.6667 19.1667C38.6667 10.6983 31.8017 3.83337 23.3333 3.83337C14.865 3.83337 8 10.6983 8 19.1667C8 27.6351 15.6667 34.5 23.3333 42.1667Z",
    fill: "#12B76A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_200_5482)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 19.5,
    r: 10.5,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_200_5482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8208 17.1595V25.2724",
    stroke: "#12B76A",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8208 19.5122L27.2841 17.1595",
    stroke: "#12B76A",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6251 25.2723H16.7432",
    stroke: "#12B76A",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7812 22.4104H24.5963",
    stroke: "#12B76A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7393 13.7277L28.6839 20.3004L29.8606 19.4152C30.2199 18.9907 30.3437 18.4208 30.1827 17.8872L29.2537 14.8555C29.0927 14.334 28.6715 13.9217 28.1389 13.764L26.7393 13.7398V13.7277Z",
    stroke: "#12B76A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6696 20.5065L22.3913 20.082L20.6572 25.054C20.5458 25.3572 20.2609 25.5391 19.9512 25.5391C19.8645 25.5391 19.7902 25.527 19.7035 25.5027C19.3195 25.3693 19.1089 24.957 19.2452 24.5811L20.6696 20.5065Z",
    fill: "#12B76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.373 18.0933L21.2393 18.8694L22.2302 16.0317C22.3293 15.7407 22.6142 15.5466 22.9362 15.5466C23.2583 15.5466 23.5308 15.7407 23.6298 16.0317L24.373 18.0933Z",
    fill: "#12B76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2435 25.5028C25.8596 25.6362 25.4384 25.4422 25.3022 25.0541L23.4194 19.8274L24.8686 19.4636L26.7018 24.569C26.8381 24.9571 26.6399 25.3694 26.2435 25.5028Z",
    fill: "#12B76A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_200_5482",
    x: 11,
    y: 7,
    width: 25,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_200_5482"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.478431 0 0 0 0 0.282353 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_200_5482"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_200_5482",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_5482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 13,
    fill: "white",
    transform: "translate(16 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/green.06725aeee12a49c94b669287fd4000c0.svg";
export { ForwardRef as ReactComponent };